<template>
  <div class="product">
    <div class="wrapper-content">
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>{{subCategoryName}}</h2>
          <p>
            <router-link to="/">{{ $t('message.Home') }}</router-link>/
            <router-link
              :to="{ name: 'subcategory', params: { subcategoryname: $route.params.categoryname }}"
            >{{categoryName}}</router-link>
            / {{subCategoryName}}
          </p>
        </div>
      </div>

      <div class="container">
        <div class="row productListingPage">
          <div class="col-lg-3 col-md-12 mt-2 productListingCategoryArea" v-show="toggle">
            <!-- leftbar filter -->
            <div class="product-left panel">
              <div id="accordion">
                <div class="card categoryCard">
                  <div class="card-header" id="headingOne">
                    <h5 class="productLeftHeading">{{ $t('message.Categories') }}</h5>
                  </div>
                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <ul>
                        <li v-for="(category, index) in categoryItems" :key="index">
                          <div
                            class="pointer"
                            v-on:click="openSubcategories(category.id,category.meta.meta_slug)"
                          >{{category.name}}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <b>Filter</b>
                <div class="card brandCard">
                  <div class="card-header" id="headingOne">
                    <h5 class="productLeftHeading">Brands</h5>
                  </div>
                  <div
                    id="collapsetwo"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <b-form-radio-group
                        id="radio-group-2"
                        v-model="brandFilter"
                        name="radio-sub-component"
                      >
                        <b-form-radio
                          v-for="(brandlist, index) in brandlists"
                          :key="index"
                          :value="brandlist.id"
                        >{{brandlist.name}}</b-form-radio>
                      </b-form-radio-group>
                    </div>
                    <b-button
                      class="btn btn-block btn-primary applyBtnFilter"
                      v-on:click="applyfilter"
                    >Apply</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9 col-md-12 productListingArea">
            <div class="product-right-listing">
              <div class="row top-head">
                <div class="col-md-12">
                  <h2>{{ $t('message.Items') }}</h2>
                  <!-- <button class="filterBtn" @click="toggle = !toggle">
                    <img src="../assets/images/filter.svg" /> Filter
                  </button>-->
                </div>
              </div>

              <h4 v-if="products==''" class="text-center mt-5">{{emptyMsg}}</h4>
              <ul id="productListing" v-else>
                <li v-for="(product, index) in products" :key="index">
                  <div
                    class="img_bx pointer"
                    v-on:click="gotoProduct(product.id,product.meta.meta_slug,product.name )"
                  >
                    <b-img-lazy
                      v-bind="mainProps"
                      :src="imageBaseUrl+ product.image"
                      blank-src="../assets/images/giphy.gif"
                      v-if="product.image"
                    />
                    <b-img-lazy
                      v-bind="mainProps"
                      :src="imageBaseUrl+ logoImg"
                      blank-src="../assets/images/giphy.gif"
                      v-else
                    />
                  </div>

                  <div class="product_cont">
                    <div
                      class="pointer"
                      v-on:click="gotoProduct(product.id,product.meta.meta_slug,product.name )"
                    >{{ product.name }}</div>

                    <!-- <div class="quantity" v-if="product.is_configurable==1">
                      <b-form-select v-on:change="optionSelected($event,product.id,index)">
                        <b-form-select-option
                          v-model="a.name"
                          v-for="(a,index) in product.product_children"
                          :key="index"
                        >{{a.name}}</b-form-select-option>
                      </b-form-select>
                    </div>-->

                    <div class="prod_info" v-if="product.is_configurable==1 ">
                      <div class="price">{{currency}} {{productPrice(product.id,index)}}</div>

                      <div class="price_bx"></div>
                    </div>

                    <div class="prod_info" v-else>
                      <div class="price">
                        <i class="fas fa-rupee-sign"></i>
                        {{currency}}{{product.price_per_unit.toFixed(2)}}
                      </div>
                      <div class="price_bx">
                        <div class="prc strike_price">{{currency}}{{product.mrp_single.toFixed(2)}}</div>
                        <div
                          class="prc perc_off"
                        >{{currency}}{{(product.mrp_single-product.price_per_unit).toFixed(2)}} off</div>
                      </div>
                    </div>

                    <div class="btn_rw" v-if="product.is_configurable==1 ">
                      <div
                        class="btn btn-border pointer"
                        v-on:click="gotoProduct(product.id,product.meta.meta_slug,product.name )"
                      >{{ $t('message.ViewDetails') }}</div>
                    </div>
                    <div class="btn_rw" v-else>
                      <div
                        class="btn btn-border pointer"
                        v-on:click="gotoStore( product)"
                      >{{ $t('message.GetOnce') }}</div>
                      <div
                        class="btn btn-primary"
                        v-on:click="gotoStore( product)"
                      >{{ $t('message.Subscribe') }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cowMilk from "@/assets/images/cowmilk.jpg";
import buffaloMilk from "@/assets/images/buffalo-milk.jpg";
import milk from "@/assets/images/milk.jpg";
import paneer from "@/assets/images/paneer.png";
import {
  getProductList,
  getMeta,
  getCategories,
  getSlugBaseInfo
} from "./../services/api";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import VueMeta from "vue-meta";
import VueLazyload from "vue-lazyload";

Vue.use(VueMeta);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "../assets/images/giphy.gif",
  attempt: 1
});
export default {
  components: {
    Loading
  },
  data() {
    return {
      mainProps: {
        center: true,
        fluidGrow: true,
        blank: true,
        blankColor: "#bbb",
        width: 600,
        height: 400,
        class: "my-5"
      },
      currency: localStorage.getItem("CurrencySymbol"),
      isLoading: false,
      fullPage: true,
      toggle: true,
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      products: [],
      brandlists: [],
      selected: "",
      productId: "",
      productIndex: "",
      productSelected: null,
      categoryItems: [],
      categoryName: "",
      subCategoryName: "",
      descriptionMeta: "",
      titleMeta: "",
      keywordsMeta: "",
      emptyMsg: "",
      logoImg: localStorage.getItem("logoImg"),
      producArray: [],
      brandFilter: "",
      options: []
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content: this.descriptionMeta
        },
        {
          name: "title",
          content: this.titleMeta
        },
        {
          name: "keywords",
          content: this.keywordsMeta
        }
      ]
    };
  },
  created() {
    this.getItemsDetails();
    var b =
      this.$route.params.categoryname.charAt(0).toUpperCase() +
      this.$route.params.categoryname.slice(1);
    this.categoryName = b.replace(/[0-9]/g, "").replace(/-/g, " ");

    var a =
      this.$route.params.name.charAt(0).toUpperCase() +
      this.$route.params.name.slice(1);
    this.subCategoryName = a.replace(/[0-9]/g, "").replace(/-/g, " ");
  },

  methods: {
    applyfilter() {
      var requestData = {
        category_id: localStorage.getItem("categoryId"),
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        brand_id: this.brandFilter,
        sub_cat_id: localStorage.getItem("subcategoryId"),
        // lat: "30.7033633",
        // lng: "76.6924969",
        vendor_id: localStorage.getItem("vendorId")
      };
      getProductList(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.products = result.data.allCategoryProductsList;
            if (this.products == "") {
              this.emptyMsg = "Sorry no products found..";
            }
            console.log("uuu", result);
            //   this.brandlists = result.data.brands;
            //   this.isLoading = false;
            //   this.getCategoriesDetails();
            //   this.getSubCategoryMeta();
            //   return false;
            // } else if (result.data.successCode === 0) {
            //   this.emptyMsg = "Sorry no products found..";
            //   this.isLoading = false;
            // }
            // if (result.data.messageText == "Record Not Found") {
            //   this.isLoading = false;
            //   this.$router.replace({ name: "404page" });
            //   return false;
            // }
          }
        })
        .catch(error => {
          return;
        });
    },
    productPrice: function(id) {
      var item = this.products.find(i => i.id == id);
      var max = -Infinity;
      var min = Infinity;
      for (var i = 0; i < item.product_children.length; i++) {
        if (item.product_children[i].price > max) {
          max = item.product_children[i].price;
        }
        if (item.product_children[i].price < min) {
          min = item.product_children[i].price;
        }
      }
      return min.toFixed(2) + "-" + max.toFixed(2);
    },
    getItemsDetails() {
      var requestData = {
        url: window.location.href,
        vendor_id: localStorage.getItem("vendorId")
      };

      this.isLoading = true;
      getSlugBaseInfo(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.products = result.data.allCategoryProductsList;
            if (this.products == "") {
              this.emptyMsg = "Sorry no products found..";
            }
            console.log("kkkk", result);
            this.brandlists = result.data.brands;
            this.isLoading = false;
            this.getCategoriesDetails();
            this.getSubCategoryMeta();
            return false;
          } else if (result.data.successCode === 0) {
            this.emptyMsg = "Sorry no products found..";
            this.isLoading = false;
          }
          if (result.data.messageText == "Record Not Found") {
            this.isLoading = false;
            this.$router.replace({ name: "404page" });
            return false;
          }
        })
        .catch(error => {
          return;
        });
    },
    gotoProduct(id, name, prodname) {
      localStorage.setItem("productName", prodname);
      localStorage.setItem("productId", id);

      var str1 = this.$route.params.categoryname;
      var str2 = this.$route.params.name;

      this.$router.push({
        name: "productdetailsingle",
        params: {
          name: name,
          subcategoryName: str2,
          categoryname: str1
        }
      });
    },
    subscribeThis(prod) {
      this.$router.replace({ name: "productdetail" });
      localStorage.setItem("productId", prod.id);
    },
    gotoStore(prod) {
      window.open(localStorage.getItem("androidPlaystore"), "_blank");

      // var existing = JSON.parse(localStorage.getItem("selectedProduct"));

      // existing = existing ? existing : [];
      // var productsToadd = { items: prod, quantity: 1 };
      // existing.push(productsToadd);

      // localStorage.setItem("selectedProduct", JSON.stringify(existing));
    },
    getSubCategoryMeta() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId"),
          type: "sub_category",
          meta_id: localStorage.getItem("subcategoryId")
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId"),
          type: "sub_category",
          meta_id: localStorage.getItem("subcategoryId")
        };
      }
      getMeta(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.titleMeta = result.data.data.meta_title;
            this.descriptionMeta = result.data.data.meta_description;
            this.keywordsMeta = result.data.data.meta_keywords;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          this.isLoading = false;
          return;
        });
    },
    openSubcategories(id, name) {
      localStorage.setItem("categoryId", id);

      this.$router.push({
        name: "subcategory",
        params: { subcategoryname: name }
      });
    },
    getCategoriesDetails() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId")
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId")
        };
      }
      getCategories(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.categoryItems = result.data.allCategoryProductsList;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    }
  }
};
</script>